// lib/api/user.ts
import api from '../api';
import Cookies from 'js-cookie';
import { setTokenCookie } from '../utils/jwt';

export interface RegisterPayload {
  email: string;
  password: string;
  firstName?: string;
  lastName?: string;
  phoneNo?: string;
}

export async function registerUser(payload: RegisterPayload) {
  const response = await api.post('/user', payload);
  return response.data;
}

export interface VerifyEmailPayload {
  otp: string;
  email: string;
}

export async function verifyEmail(payload: VerifyEmailPayload) {
  const response = await api.post('/user/verify-email', payload);
  return response.data;
}

export interface SignInPayload {
  email: string;
  password: string;
}

export async function signInUser(payload: SignInPayload) {
  const response = await api.post('/user/sign-in', payload);
  if (response.data.success) {
    const { accessToken, refreshToken } = response.data.data.tokens;
    // Use JWT expiration time from token instead of hardcoded values
    setTokenCookie('accessToken', accessToken, true);
    setTokenCookie('refreshToken', refreshToken, true);
  }
  return response.data;
}

// Add more user-related API functions here 

export async function resendOtp(email: string) {
  const response = await api.post('/user/resend-otp', { email });
  return response.data;
}

export async function viewUserProfile() {
  const accessToken = Cookies.get('accessToken');
  if (!accessToken) throw new Error('No access token found');
  const response = await api.get('/user/view-profile', {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });

  return response.data;
}

export async function editMyInfo({ firstName, lastName, phoneNo }: { firstName: string; lastName: string; phoneNo: string }) {
  const accessToken = Cookies.get('accessToken');
  if (!accessToken) throw new Error('No access token found');
  const response = await api.put('/user/edit-profile', { firstName, lastName, phoneNo }, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
  return response.data;
}

export async function editLogonDetails({ newPassword, oldPassword, confirmPassword }: { newPassword: string; oldPassword: string; confirmPassword: string }) {
  const accessToken = Cookies.get('accessToken');
  if (!accessToken) throw new Error('No access token found');
  const response = await api.put('/user/edit-profile', { newPassword, oldPassword, confirmPassword }, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
  return response.data;
}

export async function forgotPassword(email: string) {
  const response = await api.post('/user/forgot-password', { email });
  return response.data;
}

export async function forgotPasswordBySMS(phoneNo: string) {
  const response = await api.post('/user/forgot-password', { phoneNo });
  return response.data;
}

export async function resetPassword({ password, confirmPassword, token }: { password: string; confirmPassword: string; token: string }) {
  const response = await api.post('/user/reset-password', { password, confirmPassword, token });
  return response.data;
}

export async function getNotificationPreferences() {
  const accessToken = Cookies.get('accessToken');
  if (!accessToken) throw new Error('No access token found');
  const response = await api.get('/notification', {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
  return response.data;
}

export async function updateNotificationPreferences(preferences: Array<{
  name: string;
  channel: 'email' | 'sms';
  enabled: boolean;
}>) {
  const accessToken = Cookies.get('accessToken');
  if (!accessToken) throw new Error('No access token found');
  const response = await api.post('/notification', {
    preferences
  }, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
  return response.data;
}